import React, {useRef, useState} from 'react';
import {
    Box,
    Button,
    CircularProgress,
} from '@mui/material';
import {KeyboardArrowDownRounded} from '@mui-symbols-material/w300';
import OptionsMenu, {OptionsMenuOption} from '../OptionsMenu';

export type SplitButtonOption = OptionsMenuOption;

interface Props {
    primaryText: string;
    onPrimaryClick: () => void;
    options: SplitButtonOption[];
    loading?: boolean;
    disabled?: boolean;
    fullWidth?: boolean;
}

// Built from two regular contained Buttons (instead of a ButtonGroup) so size,
// colors and hover behavior stay identical to the app's normal primary buttons.
const SplitButton = ({primaryText, onPrimaryClick, options, loading, disabled, fullWidth}: Props) => {
    const anchorRef = useRef<HTMLDivElement>(null);
    const [menuOpen, setMenuOpen] = useState(false);

    const isDisabled = disabled || loading;

    return (
        <>
            <Box ref={anchorRef} sx={{display: 'flex', width: fullWidth ? '100%' : undefined}}>
                <Button
                    variant="contained"
                    fullWidth={fullWidth}
                    onClick={onPrimaryClick}
                    disabled={isDisabled}
                    startIcon={loading ? <CircularProgress size={20} color="inherit"/> : undefined}
                    sx={{
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0,
                    }}
                >
                    {primaryText}
                </Button>
                <Button
                    variant="contained"
                    disabled={isDisabled}
                    onClick={() => setMenuOpen(true)}
                    aria-haspopup="menu"
                    aria-expanded={menuOpen ? 'true' : undefined}
                    sx={{
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0,
                        borderLeft: '1px solid rgba(255, 255, 255, 0.4)',
                        minWidth: '44px',
                        px: 0,
                        flexShrink: 0,
                    }}
                >
                    <KeyboardArrowDownRounded/>
                </Button>
            </Box>
            <OptionsMenu
                anchorEl={anchorRef.current}
                open={menuOpen}
                onClose={() => setMenuOpen(false)}
                options={options}
                anchorOrigin={{vertical: 'top', horizontal: 'right'}}
                transformOrigin={{vertical: 'bottom', horizontal: 'right'}}
            />
        </>
    );
};

export default SplitButton;
